

// import React from 'react';
// import Leads1 from '../assets/Review.png';
// import Leads2 from '../assets/Review.png';
// import Leads3 from '../assets/Review.png';
// import Leads4 from '../assets/Review.png';

// const Leads = () => {
//   const stats = [
//     { id: 1, value: '1 Mn+', label: 'Happy Customers', image: Leads1 },
//     { id: 2, value: '145+', label: 'Bikes On Rent', image: Leads2 },
//     { id: 3, value: '1 Mn+ KM', label: 'Kilometres Travelled', image: Leads3 },
//     { id: 4, value: '10+', label: 'Franchise Point', image: Leads4 },
//   ];

//   return (
//     <div className="w-full h-auto px-4 sm:px-8 md:px-16 py-10">
//       {/* Title */}
//       <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#FF9630] mb-8 text-center">
//         Our Journey So Far
//       </h2>

//       {/* Stats Container */}
//       {/* <div className="grid grid-cols-2 gap-6 sm:grid-cols-4  sm:flex sm:flex-row bg-white rounded-lg border border-gray-300"> */}
//       <div className="grid grid-cols-2 gap-0 sm:gap-6 sm:grid-cols-4 sm:flex sm:flex-row bg-white rounded-lg border border-gray-300">

//         {stats.map((stat) => (
//           <div
//             key={stat.id}
//             className="flex flex-col items-center text-center p-6 sm:border-gray-200"
//           >
//             <img
//               src={stat.image}
//               alt={stat.label}
//               className="w-full sm:w-3/4 "
//             /> {/* Image */}
//             <p className="text-lg sm:text-xl font-bold text-amber-700">
//               {stat.value}
//             </p>
//             <p className="text-sm text-gray-700">{stat.label}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Leads;


import React from 'react';
import Leads1 from '../assets/Review.png';
import Leads2 from '../assets/Review.png';
import Leads3 from '../assets/Review.png';
import Leads4 from '../assets/Review.png';

const Leads = () => {
  const stats = [
    { id: 1, value: '1 Mn+', label: 'Happy Customers', image: Leads1 },
    { id: 2, value: '145+', label: 'Bikes On Rent', image: Leads2 },
    { id: 3, value: '1 Mn+ KM', label: 'Kilometres Travelled', image: Leads3 },
    { id: 4, value: '10+', label: 'Franchise Point', image: Leads4 },
  ];

  return (
    <div className="w-full h-auto px-4 sm:px-8 md:px-16 py-10">
      {/* Title */}
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#FF9630] mb-8 text-center">
        Our Journey So Far
      </h2>

      {/* Stats Container */}
      <div className="grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4 bg-white rounded-lg border border-gray-300">
        {stats.map((stat) => (
          <div
            key={stat.id}
            className="flex flex-col items-center text-center p-6 sm:border-gray-200"
          >
            <img
              src={stat.image}
              alt={stat.label}
              className="w-full sm:w-1/2"
            />
            <p className="text-lg sm:text-xl font-bold text-[#FF9630]">
              {stat.value}
            </p>
            <p className="text-sm text-gray-700">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Leads;
